import { Skeleton } from '../../ui/skeleton'
import React from 'react'
import { PageContainer } from 'src/component/page-container/page-container'

export const WorkoutStatsSkeleton = (): React.ReactElement => {
  return (
    <PageContainer>
      <div className="py-6 md:py-[82px]">
        <Skeleton className="mb-10 h-10 w-48 rounded-md bg-tertiary-grey" />
        <div className="grid grid-cols-1 gap-7 sm:grid-cols-2 lg:grid-cols-4">
          <Skeleton className="h-[151px] w-full rounded-md bg-tertiary-grey" />
          <Skeleton className="h-[151px] w-full rounded-md bg-tertiary-grey" />
          <Skeleton className="h-[151px] w-full rounded-md bg-tertiary-grey" />
          <Skeleton className="h-[151px] w-full rounded-md bg-tertiary-grey" />
        </div>
      </div>
    </PageContainer>
  )
}
